import { styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProviderProps } from 'notistack';

import { colorSystem, h4 } from '../../theme';
import { STATUS_ICONS, type StatusIconStatus } from '../StatusIcon/statusIcons';
import { SnackbarCloseButton } from './SnackbarCloseButton';

const SnackbarContent = styled(MaterialDesignContent)(() => ({
    '& #notistack-snackbar': {
        padding: '0px',
    },
    '&.notistack-MuiContent': {
        ...h4,
        lineHeight: '24px',
        borderRadius: 8,
        padding: 16,
    },
    '&.notistack-MuiContent-success': {
        backgroundColor: colorSystem.green[8],
    },
    '&.notistack-MuiContent-info': {
        backgroundColor: colorSystem.neutral[9],
    },
    '&.notistack-MuiContent-error': {
        backgroundColor: colorSystem.red[8],
    },
    '&.notistack-MuiContent-warning': {
        backgroundColor: colorSystem.yellow[8],
    },
    '& .snackbar-close-button': {
        opacity: 0.5,
        transition: 'opacity 200ms ease',
    },
    // Also while it has the keyboard's focus, so its ring shows in full.
    '&:hover .snackbar-close-button, & .snackbar-close-button.Mui-focusVisible': {
        opacity: 1,
    },
}));

/** Pass a light shade, which reads on the dark snackbar; 20px and the 8px gap match notistack's own icons. */
function snackbarIcon(status: StatusIconStatus, color: string): JSX.Element {
    const Glyph = STATUS_ICONS[status].filled;
    return <Glyph size={20} color={color} style={{ marginInlineEnd: 8 }} />;
}

export const DefaultSnackbarProviderProps: SnackbarProviderProps = {
    Components: {
        default: SnackbarContent,
        error: SnackbarContent,
        info: SnackbarContent,
        success: SnackbarContent,
        warning: SnackbarContent,
    },
    autoHideDuration: 6000,
    maxSnack: 8,
    anchorOrigin: {
        horizontal: 'center',
        vertical: 'top',
    },
    action: (snackbarKey) => <SnackbarCloseButton snackbarKey={snackbarKey} />,
    iconVariant: {
        info: snackbarIcon('info', colorSystem.blue[1]),
        warning: snackbarIcon('warning', colorSystem.yellow[1]),
        success: snackbarIcon('success', colorSystem.green[1]),
        error: snackbarIcon('error', colorSystem.red[1]),
    },
};
